/* tslint:disable:indent */
import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Section} from '../../model/section';
import {SubSection} from '../../model/sub-section';
import {Group} from '../../model/group';
import {PreferenceMessages} from '../../../../shared/models/component-messages/preference-messages';
import {Field} from '../../model/field';
import {StepperBuilderService} from '../../../../avisDePub/creer/services/stepper.builder.service';
import {TranslateService} from '@ngx-translate/core';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import {EformDataService} from "../../services/eform-data.service";
import {EFormsOrgService} from '../../services/e-forms-org.service';
import {EformElementsService} from '../../services/efom-elements.service';
import {EformDuplicableEntityService} from '../../services/eform-duplicable-entity.service';
import {EformsToolsService} from '../../services/e-forms-tools.service';
import {ENoticeTypeXsd} from '../../../../../models/enums/enotice-type-xsd.enum';
import {IndexTrackerService} from "../../services/index-tracker.service";
import {EformConditionsV2Service} from "../../services/eform-conditions-v2.service";
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {EformAccordionService} from '../../services/eform-accordion.service';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['../e-forms-generator/e-forms-generator.component.css']
})
export class SectionComponent implements OnInit, OnDestroy {
  @Input() indexPage: any;
  @Input() section: Section = {} as Section;
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() repeatablePath: string;
  @Input() noticeValue: any;
  @Input() prefixId: any;
  @Input() linkForRouter: string;
  @Input() getRepeatablePathWithIndexForSection: (section) => string;
  repeatablePathWithIndex: string;
  repeatablePathForElementDuplicable: string;
  public preferenceMessages = new PreferenceMessages();
  rgpdWarning: boolean = false;
  rgpdMessage: string = "L'intégralité des données d'organisation a vocation à être publié dans les supports d'avis de publicité sélectionnés : il convient de ne procéder qu'à la saisie de coordonnées génériques ne constituant pas des données à caractère personnel.";
  orgElementsCount: number = 1;
  displayedElementIndex: number = 0;
  subSectionDuplicable: any;
  isAfterOrganizationLoading: boolean = false;
  private destroy$ = new Subject<void>();
  // 🔧 FIX 2026-02-11: Protection contre les créations multiples d'éléments duplicables
  private isCreatingDuplicableElement: boolean = false;

  constructor(private translateService: TranslateService,
              private stepperBuilderService: StepperBuilderService,
              private canNavigateInStepperService: CanNavigateInStepperService,
              private eformDataService: EformDataService,
              private eFormsOrgService: EFormsOrgService,
              private eformElementsService: EformElementsService,
              private eformDuplicableEntityService: EformDuplicableEntityService,
              private eformsToolsService: EformsToolsService,
              private cd: ChangeDetectorRef,
              private indexTrackerService: IndexTrackerService,
              private eformConditionV2Service: EformConditionsV2Service,
              private eformAccordionService: EformAccordionService
  ) {
  }

  ngOnInit(): void {
    this.eformDuplicableEntityService.listDuplicableEntity.pipe(
      takeUntil(this.destroy$)
    ).subscribe(duplicableElementsList => {
      this.orgElementsCount = duplicableElementsList.filter(item => item.id.includes('ORG')).length;
    });
    this.repeatablePathWithIndex = this.getRepeatablePathWithIndexForSection(this.section);
    if (this.section?._label.includes("Change")) {
      if (this.canNavigateInStepperService.eformMotifChange.includes('cancel')) {
        this.section._label = "motif_modification.cancel"
      } else {
        this.section._label = "motif_modification.changement"
      }
    }
    // ✅ FIX 2026-02-02: Ne pas ajouter une organisation ici si c'est un avis lié (isAvisLieCreate)
    // car le stepper.component.ts gère déjà l'ajout de la 2ème organisation pour les avis liés
    // Cela évite le double ajout qui créait 3 organisations au lieu de 2
    // ✅ FIX 2026-02-03: Ne pas ajouter automatiquement si l'avis existe déjà (mode édition)
    // L'utilisateur a pu supprimer volontairement une organisation, on ne doit pas la recréer
    const isCreationMode = this.eformDuplicableEntityService.isCreationButBeforeFirstSave.getValue();
    if (this.eFormsOrgService.getNeedSecondOrganization() && this.section.baseId == "GR-Organisations-Section" && this.section.subsections[0]?.groups[0]?.id !== 'GR-Organisations' && this.linkForRouter.includes('creerAvisPub') && !this.canNavigateInStepperService.isAvisLieCreate && isCreationMode) {
      //Suppression temporaire du point de contact spécifique
      if (this.section?.subsections[0]?.groups) {
        this.section.subsections[0].groups = this.section.subsections[0].groups.filter(g => g.id != 'GR-Touch-Point');
      }
      this.newSubSection(this.section.subsections[0]);
    }
    if (this.section?._label.includes("Organisations")) {
      this.subSectionDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.organisationNotice));
      //Suppression temporaire du point de contact spécifique
      if(this.subSectionDuplicable?.subGroups){
        this.subSectionDuplicable.subGroups = this.subSectionDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
      }
      this.rgpdWarning = true;
      // Initialiser isAfterOrganizationLoading à true pour afficher la première organisation par défaut
      this.isAfterOrganizationLoading = true;
    } else {
      this.rgpdWarning = false;
    }
  }

  isDuplicableElement() {
    return this.eformDuplicableEntityService.isSectionDuplicatedPerElement(this.section)
      && !this.eformDuplicableEntityService.isCreationButBeforeFirstSave.getValue();
  }

  displaySubSection(index: number) {
    return !this.section.subsections[0]?.hidden && index === this.displayedElementIndex && this.isAfterOrganizationLoading;
  }

  loadDuplicableElement($event) {
    //on ferme avant, tout les accordeons
    this.displayedElementIndex = -1;
    this.cd.detectChanges();
    const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire].toLowerCase();

    // ✅ FIX 2026-03-06: Nettoyer le FormGroup AVANT de charger les nouvelles données
    // Sans ce nettoyage, les contrôles de l'organisation précédente restent dans le FormArray
    // et le getRawValue() envoie les données de l'ancienne org au backend (ex: ORG-0001 au lieu de ORG-0003)
    if (this.formGroup) {
      this.eformDataService.clearDuplicableElementControls(this.formGroup, 'ORG', firstItemName);
    }

    const path = [
      'noticeValue',
      firstItemName,
      'ublextensions',
      'ublextension',
      '0',
      'extensioncontent',
      'eformsextension',
      'organizations'
    ];
    // Assurez-vous que toutes les propriétés existent, si elle n'existe pas on les initialise
    const target = this.eformDataService.ensurePropertyPath(this, path);

    // Assignez la valeur
    target.organization = [this.eformsToolsService.propertyNamesToLowercase($event)];
    this.subSectionDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.organisationNotice));
    //Suppression temporaire du point de contact spécifique
    if(this.subSectionDuplicable?.subGroups){
      this.subSectionDuplicable.subGroups = this.subSectionDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
    }

    this.displayedElementIndex = $event.index;
    this.isAfterOrganizationLoading = true;

    // ✅ FIX 2026-03-06: Mettre à jour displayedRealIndex pour que regenerateNullOrganizationIds
    // puisse calculer le bon ID technique (ORG-0001, ORG-0002, ORG-0003...)
    this.eformConditionV2Service.setDisplayedRealIndex('ORG', $event.index);

    // ✅ FIX 2025-12-23: Forcer Angular à redessiner le template pour afficher la sous-section
    this.cd.markForCheck();

    // ✅ FIX: Réinitialiser repeatablePathForElementDuplicable pour utiliser le bon index
    // Cela corrige le problème de persistance des champs (comme BT-507-Organization-Company)
    // lorsqu'on change d'organisation. Le chemin sera reconstruit avec le bon index.
    this.repeatablePathForElementDuplicable = undefined;
  }

  getCounterArray(): number[] {
    return Array(this.orgElementsCount);
  }

  newField($event) {
    const field: Field = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.section.fields.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(field.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    field.id = field.id.split('_')[0] + '_' + elementNumber;
    const indexToSplice = this.section.fields.filter(el => el.id.startsWith($event.id)).length
    this.section.fields.splice((this.section.fields as any).findIndex(el => el.id === $event.id) + indexToSplice, 0, field);
    this.repeatablePath = field.jsonPath + '_SEPSEP_' + (elementNumber);
  }

  deleteField($event: any) {
    this.section.fields = this.section.fields.filter(obj => obj !== $event);
  }

  getSectionTitle() {
    //on retire 1 car la sous-section 0 n'existe pas
    if (this.indexPage) {
      const indexSubsection = Number(this.indexPage.toString().split('.')[1]) - 1;
      const titre: string = this.translateService.instant(this.section._label);
      // ✅ FIX 2026-03-18: Protéger contre les sous-sections inexistantes ou sans _label
      // Quand subsections[indexSubsection] n'existe pas ou que _label est undefined,
      // translateService.instant(undefined) retourne "null" (string), causant "5.5 Lot - null"
      let sousTitre: string = null;
      const subsection = this.section.subsections?.[indexSubsection];
      if (subsection && subsection._label) {
        sousTitre = this.translateService.instant(subsection._label);
      }

      if (this.indexPage.toString().includes('.')) {
        //Si l'indexe contient une sous-section on simplifie le titre
        if (sousTitre && titre !== sousTitre) {
          return this.indexPage + ' ' + titre + ' - ' + sousTitre;
        }
        return this.indexPage + ' ' + titre;
      } else {
        let index = this.section.index;
        return index + '. ' + this.translateService.instant(this.section._label);
      }
    }
  }

  haveToHide(index: number) {
    //Si l'indexe de la page ne contient pas de point c'est qu'il n'y a pas de sous-sections, donc il faut tout afficher
    if (this.indexPage?.toString().includes('.')) {
      return Number(this.indexPage.toString().split('.')[1]) !== index + 1;
    } else {
      return false;
    }
  }

  private isDeletable(elementId) {
    let baseId = elementId;
    if (elementId.includes('_')) {
      baseId = elementId.split('_')[0];
    }
    let filteredElements = this.section.subsections.filter(el => el.id === baseId || el.id.includes(baseId + '_'));
    //Si on en a plus d'un le bouton supprimer doit etre dispo sur toutes
    if (filteredElements.length > 1) {
      filteredElements.forEach(s => s.deletable = true);
    } else {
      //Sinon aucun bouton supprimer
      filteredElements.forEach(s => s.deletable = false);
    }
  }

  newSubSection(subsection) {
    const subSection: SubSection = Object.assign({}, JSON.parse(JSON.stringify(subsection)));
    const ids = this.section.subsections.map(gr => gr.id);
    subSection.groups = this.eformElementsService.clearRepeatedGroups(subSection.groups);

    //Suppression temporaire du point de contact spécifique dans les groups
    if(subSection?.groups){
      subSection.groups = subSection.groups.filter(g=>g.id !='GR-Touch-Point');
    }

    let elementNumber = 1;
    if (subSection.id.includes("_")) {
      subSection.repeatedId = subSection.id.split('_').slice(1).map(Number);
      subSection.id = subSection.id.split('_').slice(0, -1).join('_');
    } else {
      subSection.repeatedId = [0];
    }
    // On cherche le premier id disponible pour la nouvelle sous-section
    while (ids.includes(subSection.id + '_' + elementNumber)) {
      elementNumber++;
    }

    subSection.id = subSection.id.split('_')[0];
    subSection.repeatedId.splice(-1, 1, elementNumber);
    subSection.repeatedId.forEach(id => subSection.id += '_' + id);

    subSection.fields.forEach(field => field.isNewFromSameStep = true);
    subSection.groups = this.eformElementsService.updateIdsRecursively(subSection.groups, [...subSection.repeatedId], true);

    this.section.subsections.push(subSection);
    this.repeatablePath = subSection.jsonPath + '_SEPSEP_' + (elementNumber);
    this.repeatablePathForElementDuplicable = this.repeatablePathForElementDuplicable?.replace(/(\[\]\d+)(?!.*\[\]\d+)/, `[]${elementNumber}`)
    this.isDeletable(subsection.id);

    // 🔧 FIX 2026-02-26: Notifier le service pour replier les autres accordéons du même type
    // et garder ouvert uniquement le nouveau créé
    const groupType = this.getGroupType(subSection.id);
    if (groupType) {
      // Petit délai pour permettre au DOM de se mettre à jour avec le nouveau groupe
      setTimeout(() => {
        this.eformAccordionService.collapseOthers(groupType, subSection.id);
      }, 100);
    }
  }

  deleteSubSection(subsection: any) {
    this.section.subsections = this.section.subsections.filter(obj => obj !== subsection);

    // On récupère l'index de la sous-section supprimée
    let index = 0;
    if (subsection.id.includes('_')) {
      index = subsection.repeatedId.slice(-1)[0];
    } else {
      index = 0;
    }

    this.section.subsections.filter(subSection => subSection.id.includes(subsection.id.split("_")[0])).forEach(subSection => {
      if (subSection.repeatedId && subSection.repeatedId.slice(-1)[0] > index) {
        subSection.repeatedId.push(subSection.repeatedId.pop() - 1);
        subSection.id = subSection.id.split("_")[0];
        subSection.repeatedId.forEach(id => subSection.id += '_' + id);
        subSection.groups = this.eformElementsService.updateIdsRecursively(subSection.groups, [...subSection.repeatedId]);
      }
      if (!subsection.id.includes("_") && subSection.repeatedId.slice(-1)[0] === 0) {
        subSection.id = subSection.id.slice(0, -2);
      }
    });


    //On supprime le groupe du formulaire
    let pathElements: Array<string> = subsection.jsonPath.split('.');
    pathElements.pop();
    this.formGroup = this.stepperBuilderService.removeLastControl(this.formGroup, pathElements, this.getRepeatablePathWithIndexForSubSection(subsection, true));
    this.isDeletable(subsection.id);
  }


  newGroup($event: any) {
    const group: Group = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids: any = this.section.groups.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(group.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    group.id = group.id.split('_')[0] + '_' + elementNumber;
    let seekingId = group.id.split('_')[0];
    const regex = new RegExp(`^${seekingId}`);
    this.section.groups.splice(ids.findLastIndex(value => regex.test(value)) + 1, 0, group);
    this.repeatablePath = group.jsonPath.replace('.val', '') + '_SEPSEP_' + (elementNumber);
    this.repeatablePathForElementDuplicable = this.repeatablePathForElementDuplicable?.replace(/(\[\]\d+)(?!.*\[\]\d+)/, `[]${elementNumber}`)

    // 🔧 FIX 2026-02-26: Notifier le service pour replier les autres accordéons du même type
    // et garder ouvert uniquement le nouveau créé
    const groupType = this.getGroupType(group.id);
    if (groupType) {
      // Petit délai pour permettre au DOM de se mettre à jour avec le nouveau groupe
      setTimeout(() => {
        this.eformAccordionService.collapseOthers(groupType, group.id);
      }, 100);
    }
  }

  /**
   * 🔧 FIX 2026-02-26: Extrait le type de groupe à partir d'un ID
   * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
   */
  getGroupType(elementId: string): string {
    return this.eformAccordionService.extractGroupType(elementId);
  }


  deleteGroup($event: any) {
    let _group = $event.group;
    let _repeatablePathWithIndex = $event.repeatablePathWithIndex

    // 🔧 FIX 2026-02-16: On récupère l'index AVANT de modifier la liste
    let indexToDelete = 0;
    if (_group.id.includes('_')) {
      indexToDelete = +_group.id.split('_')[1];
    }

    //On supprime le groupe du formulaire avec l'index explicite AVANT de modifier la liste
    let pathElements: Array<string> = _group.jsonPath.split('.');
    pathElements.pop();
    this.formGroup = this.stepperBuilderService.removeLastControl(this.formGroup, pathElements, _repeatablePathWithIndex, indexToDelete);

    // On supprime le groupe de la section (affichage) APRÈS la suppression du contrôle
    this.section.groups = this.section.groups.filter(obj => obj !== _group);

    //On décale les indexes pour les groupes situé après celui qui est supprimé
    if (_group.id.includes('_')) {
      this.section.groups.forEach(group => {
        if (+group.id.split('_')[1] > indexToDelete) {
          group.id = group.id.split('_')[0] + '_' + (+group.id.split('_')[1] - 1);
        }
      });
    }
  }

  getIndex(id: string) {
    let element = id.split("_");
    return {value: id.split("_")[element.length - 1], bool: element.length > 1};
  }

  getStepId() {
    return Number.isNaN(+this.indexPage.toString().split('.')[1] - 1) ? this.section.id : this.section?.id.concat('_').concat((+(this.indexPage.split('.')[1]) - 1).toString());
  }

  getRepeatablePathWithIndexForInput = (field): string => {
    if (field.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, field.jsonPath, Number((this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0')))
      return pathToReturn + this.isRepeatableField(field) + field.jsonPath + '_INDEX_' + (this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0');
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathForDuplicableElement = (): string => {
    return this.repeatablePathForElementDuplicable
  }

  isRepeatableField(field) {
    if (field._repeatable) {
      let tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2);
      return tempJsonPath + '_INDEX_' + (this.getArray(field, tempJsonPath)) + '_SEPSEP_';
    } else {
      return '';
    }
  }

  getRepeatablePathWithIndexForGroup = (group): string => {
    if (group.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, group.jsonPath, Number((this.getIndex(group.id).bool ? this.getIndex(group.id).value : '0')))
      return pathToReturn + group.jsonPath + '_INDEX_' + (this.getIndex(group.id).bool ? this.getIndex(group.id).value : '0');
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathWithIndexForSubSection = (subSection, isForDelete): string => {
    if (subSection.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }

      let index = this.eformDataService.getArray(subSection, this.formGroup, this.repeatablePathWithIndex, undefined, undefined, undefined, undefined, undefined, isForDelete);

      if(this.prefixId === 'GR-Lot'){
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable?.replace(/(\[\]\d+)(?!.*\[\]\d+)/, "[]"), subSection.jsonPath, (this.eformDuplicableEntityService.actuallyIndexLotOrPar != -1?this.eformDuplicableEntityService.actuallyIndexLotOrPar : 0))
      }else if(this.isDuplicableElement()){
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable?.replace(/(\[\]\d+)(?!.*\[\]\d+)/, "[]"), subSection.jsonPath, this.displayedElementIndex)
        return pathToReturn + subSection.jsonPath + '_INDEX_0';
      }else{
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, subSection.jsonPath, Number(index), undefined, isForDelete)
      }
      return pathToReturn + subSection.jsonPath + '_INDEX_' + (index);
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getArray(actual, tempJsonPath?) {
    let tempControl;
    let i = 0;
    let pathElements = tempJsonPath?.split('.') ?? actual.jsonPath.split('.');
    if (!tempJsonPath) {
      pathElements.pop();
    }
    pathElements.forEach(elements => {
      if (i == 0) {
        tempControl = elements.includes('[]') ? (<any>this.formGroup).controls[elements.replace('[]', '')].controls[0]
          : this.formGroup.controls[elements];
      } else {
        if (elements.includes('[]')) {
          if (i == pathElements.length - 1) {
            tempControl = tempControl?.controls[elements.replace('[]', '')]
          } else {
            tempControl = tempControl?.controls[elements.replace('[]', '')]?.controls[this.eformDataService.getArrayIndex(elements, this.repeatablePathWithIndex)];
          }
        } else {
          tempControl = tempControl?.controls[elements];
        }
      }
      i++;
    });
    return tempControl?.controls?.length > 0 ? this.findIndexDependingOnId(actual, tempControl) : 0;
  }

  private findIndexDependingOnId(actual, tempControl) {
    //On cherche l'index du dernier element partageant le même baseId
    let previousId = actual.baseId;
    if (actual.id.includes('_') && +actual.id.split('_')[1] > 1) {
      previousId += '_' + (+actual.id.split('_')[1] - 1);
    }
    let previousIndex = +tempControl.controls.findIndex(c =>
      c.prefixEform === previousId);
    //Si on le trouve, on y ajoute 1 pour avoir notre index, sinon on recupére la longueur du tableau
    //(soit on l'ajoute à la suite d'un autre qui porte le mm baseId soit on le met à la fin)
    return previousIndex === -1 ? tempControl.controls.length : previousIndex + 1;
  }

  parcoursUtilisateur(section) {
    return section.parcoursUtilisateur?.messageInfo;
  }

  isDuplicableElementDeletable(): boolean {
    return this.orgElementsCount > 1;
  }

  getIncr(id) {
    return id.split('_').slice(-1) == undefined ? 0 : id.split('_').slice(-1);
  }

  newDuplicableElement(subSection: SubSection) {
    const type = subSection._idScheme;

    // Protection contre les créations multiples
    if (this.isCreatingDuplicableElement) {
      return;
    }
    this.isCreatingDuplicableElement = true;

    //On incrémente l'index
    this.indexTrackerService.addDuplicableElement(type);
    //On ajoute le flatFields qui va recupérer les informations
    this.eformConditionV2Service.addDuplicableFieldsByType(type);
    this.eformDuplicableEntityService.addNewDuplicableEntity(this.eformDuplicableEntityService.currentAvisId.getValue(), type).subscribe((data) => {

      // ✅ FIX 2026-03-06: Recharger la liste depuis le backend pour obtenir le vrai ID (ex: ORG-0003)
      // Sans ça, l'org reste un "_isNewElement" et le frontend ne connaît pas son vrai ID backend.
      // Cela cause: sauvegarde envoie ORG-0001 au lieu de ORG-0003, backend écrase l'org 1.
      this.eformDuplicableEntityService.getIdsAndNamesByAvisId(this.eformDuplicableEntityService.currentAvisId.getValue()).subscribe(listIdsAndNames => {

        // Mettre à jour la liste AVANT de définir l'index pour que reloadDuplicableElement
        // trouve le vrai élément (et non un _isNewElement)
        this.eformDuplicableEntityService.listDuplicableEntity.next(listIdsAndNames);

        // Recréer subSectionDuplicable avec une copie propre
        this.subSectionDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.organisationNotice));
        //Suppression temporaire du point de contact spécifique
        if(this.subSectionDuplicable?.subGroups){
          this.subSectionDuplicable.subGroups = this.subSectionDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
        }

        if (type === 'ORG') {
          this.orgElementsCount = listIdsAndNames.filter(e => e && e.id && e.id.startsWith('ORG-')).length;
        }
        const newIndex = this.orgElementsCount - 1;

        this.displayedElementIndex = JSON.parse(JSON.stringify(newIndex));

        // ✅ FIX 2025-12-23: Définir displayedRealIndex pour que les rescans utilisent le bon index
        this.eformConditionV2Service.setDisplayedRealIndex(type, newIndex);

        // ✅ FIX 2025-12-18: Notifier le service pour fermer l'ancien accordéon et ouvrir le nouveau
        this.eformDuplicableEntityService.setDisplayedElementIndex(type, newIndex);

        // Réinitialiser repeatablePathForElementDuplicable pour le nouvel index
        this.repeatablePathForElementDuplicable = undefined;

        // ✅ FIX NG0100: Utiliser markForCheck au lieu de detectChanges
        this.cd.markForCheck();

        // Réinitialiser le flag après la création
        this.isCreatingDuplicableElement = false;
      });
    }, (error) => {
      // Réinitialiser le flag en cas d'erreur
      this.isCreatingDuplicableElement = false;
    });
  }

  deleteDuplicableElement(subSection: SubSection, index) {
    const type = subSection._idScheme;

    // ✅ FIX 2026-01-28: Si on supprime une organisation, désactiver needSecondOrganization
    // pour éviter qu'elle soit recréée automatiquement quand on change de section
    if (type === 'ORG') {
      this.eFormsOrgService.setNeedSecondOrganization(false);
    }

    //On diminue le compteur de 1 et remet le lastIndexes sur le premier
    this.indexTrackerService.removeDuplicableElement(type);
    //Suppression dans flatFields
    this.eformConditionV2Service.removeDuplicableFieldByTypeAndIndex(type, index );
    this.eformDuplicableEntityService.deleteDuplicableEntity(this.eformDuplicableEntityService.currentAvisId.getValue(), index + 1, type).subscribe((data) => {
      if (type === 'ORG') {
        this.orgElementsCount--;
      }

      // ✅ FIX 2026-02-10: Calculer le nombre d'éléments restants pour ce type (pas seulement ORG)
      const currentList = this.eformDuplicableEntityService.listDuplicableEntity.getValue();
      let elementsCount = currentList.filter(item => item && item.id && item.id.startsWith(type + '-')).length;

      // ✅ FIX 2026-02-05: Calculer le nouvel index à afficher AVANT de fermer les accordéons
      // Si on supprime l'élément actuellement affiché ou un élément avant lui, on doit recalculer
      // Pour garantir qu'un élément reste visible après suppression (s'il en reste)
      let newDisplayedIndex = -1;
      if (elementsCount > 0) {
        // Si on supprimait un élément AVANT celui qui était affiché, l'index affiché doit diminuer de 1
        // Si on supprimait l'élément affiché lui-même, on affiche le premier (index 0)
        // Si on supprimait un élément APRÈS celui affiché, l'index reste le même
        const previousDisplayedIndex = this.eformDuplicableEntityService.getDisplayedElementIndex(type);
        if (previousDisplayedIndex === index) {
          // On supprime l'élément actuellement affiché -> afficher le premier
          newDisplayedIndex = 0;
        } else if (previousDisplayedIndex > index) {
          // On supprime un élément avant celui affiché -> l'index diminue de 1
          newDisplayedIndex = previousDisplayedIndex - 1;
        } else {
          // On supprime un élément après celui affiché -> l'index reste le même
          newDisplayedIndex = previousDisplayedIndex;
        }
        // S'assurer que l'index est dans les limites
        if (newDisplayedIndex >= elementsCount) {
          newDisplayedIndex = elementsCount - 1;
        }
        if (newDisplayedIndex < 0) {
          newDisplayedIndex = 0;
        }
      }

      // Fermer temporairement tous les accordéons pour forcer le rafraîchissement
      this.displayedElementIndex = -1;
      this.eformDuplicableEntityService.closeAllAccordions(type);

      // ✅ FIX 2026-02-03: Mettre à jour la liste des entités duplicables pour synchroniser avec la BDD
      // Cela assure que si l'utilisateur quitte et revient, la liste sera cohérente
      // ✅ FIX 2026-02-10: Réutiliser currentList déjà calculé plus haut
      const updatedList = currentList.filter((item, i) => {
        // Supprimer l'élément du type correspondant à l'index supprimé
        if (item && item.id && item.id.startsWith(type + '-')) {
          const itemIndex = parseInt(item.id.split('-')[1], 10);
          return itemIndex !== index + 1;
        }
        return true;
      });
      // Réindexer les éléments restants du même type
      let reindexedList = updatedList.map(item => {
        if (item && item.id && item.id.startsWith(type + '-')) {
          const itemIndex = parseInt(item.id.split('-')[1], 10);
          if (itemIndex > index + 1) {
            const newIndex = itemIndex - 1;
            const newId = type + '-' + String(newIndex).padStart(4, '0');
            return { ...item, id: newId };
          }
        }
        return item;
      });
      this.eformDuplicableEntityService.listDuplicableEntity.next(reindexedList);

      // ✅ FIX 2026-02-10: Recalculer elementsCount après la réindexation pour être sûr
      elementsCount = reindexedList.filter(item => item && item.id && item.id.startsWith(type + '-')).length;

      // Réindexer les éléments chargés après suppression
      this.eformDuplicableEntityService.reindexLoadedElementsAfterDeletion(type, index, elementsCount);

      // ✅ FIX 2026-02-05: Rouvrir automatiquement un accordéon si des éléments restent
      // Utiliser setTimeout pour laisser Angular mettre à jour le DOM après la suppression
      if (newDisplayedIndex >= 0 && elementsCount > 0) {
        setTimeout(() => {
          // Réinitialiser repeatablePathForElementDuplicable pour le nouvel index
          this.repeatablePathForElementDuplicable = undefined;

          // ✅ FIX 2026-02-10: Recharger les données en fonction du type, pas seulement organisationNotice
          let dataSource = null;
          switch (type) {
            case 'ORG':
              dataSource = this.eformDuplicableEntityService.organisationNotice;
              break;
            case 'RES':
              dataSource = this.eformDuplicableEntityService.resultNotice;
              break;
            case 'TEN':
              dataSource = this.eformDuplicableEntityService.tenderNotice;
              break;
            case 'CON':
              dataSource = this.eformDuplicableEntityService.settledContractNotice;
              break;
            case 'TPA':
              dataSource = this.eformDuplicableEntityService.tenderingPartyNotice;
              break;
            default:
              dataSource = this.eformDuplicableEntityService.organisationNotice;
          }

          if (dataSource) {
            this.subSectionDuplicable = JSON.parse(JSON.stringify(dataSource));
            //Suppression temporaire du point de contact spécifique
            if(this.subSectionDuplicable?.subGroups){
              this.subSectionDuplicable.subGroups = this.subSectionDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
            }
          }

          // ✅ Mettre à jour l'index affiché localement
          this.displayedElementIndex = newDisplayedIndex;

          // ✅ Marquer l'élément comme non-chargé pour forcer le rechargement
          this.eformDuplicableEntityService.unmarkDuplicableElementAsLoaded(type, newDisplayedIndex);

          // ✅ Déclencher le rechargement via triggerDuplicableEntity
          // Note: On ne doit PAS appeler setDisplayedElementIndex avant car toggleAccordionIfNeeded
          // vérifie si index !== displayedIndex, donc on doit garder displayedIndex à -1
          const duplicableElementId = this.section.subsections[0]?.id || 'GR-Organisations';
          this.eformDuplicableEntityService.triggerDuplicableEntity(duplicableElementId, newDisplayedIndex);

          this.cd.markForCheck();
        }, 150);
      }

      // ✅ FIX NG0100: Utiliser markForCheck au lieu de detectChanges
      this.cd.markForCheck();

      // Force rescan de flatFields après la suppression pour synchroniser avec le formulaire
      this.eformConditionV2Service.forceRescanAfterDeletion(this.formGroup, type, index);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


